<template>
  <div v-show="parentContainer.pageCount > 1" class="VueCarousel-pagination">
    <div class="VueCarousel-dot-container">
      <div
        class="VueCarousel-dot"
        v-bind:class="{ 'VueCarousel-dot--active': (index === parentContainer.currentPage) }"
        v-for="(page, index) in parentContainer.pageCount"
        v-on:click="parentContainer.goToPage(index)"
        :style="`
          margin-top: ${ (parentContainer.paginationPadding * 2).toString() + parentContainer.units};
          padding: ${parentContainer.paginationPadding.toString() + parentContainer.units};
        `"
      >
        <div class="VueCarousel-dot-inner" v-html="getPagin(index)"></div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "Pagination",
    data() {
      return {
        parentContainer: this.$parent,
      }
    },
    created: function () {

    },
    methods: {
      getPagin: function (index) {
        var pagin = this.parentContainer.$slots
          && this.parentContainer.$slots.default
          && this.parentContainer.$slots.default.filter(
            slot => slot.tag && slot.tag.indexOf("Slide") > -1
          )[index].elm.__vue__.pagin;

        return pagin;
      }
    }
  }
</script>

<style scoped>
  .VueCarousel-pagination {
    width: 100%;
    float: left;
    text-align: center;
  }

  .VueCarousel-dot-container {
    display: inline-block;
    margin: 0 auto;
  }

  .VueCarousel-dot {
    float: left;
    cursor: pointer;
  }

  .VueCarousel-dot-inner {
    border-radius: 100%;
  }
  .VueCarousel-dot.VueCarousel-dot--active {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/Carousel/Pagination.vue